import {
  ArrowRed,
  Div,
  H3,
  H5,
  Icon as IconWrapper,
  lightTheme,
  Provider,
  AllProvidersModal,
  Box,
  VDriveProvider,
  NumberType,
  formatAmount,
} from '@vgrubs/components';
import { Dispatch, SetStateAction } from 'react';

export const SummaryComponent = ({
  label,
  amount,
  Icon,
  color,
  byProvider,
  setAllProvidersModal,
  currency,
  customArrow,
}: {
  label: string;
  amount: number;
  Icon:
    | (() => JSX.Element)
    | ((props: React.SVGProps<SVGSVGElement>) => JSX.Element);
  color: string;
  byProvider: { provider: Provider | VDriveProvider; amount: number }[];
  setAllProvidersModal: Dispatch<SetStateAction<AllProvidersModal | null>>;
  currency: NumberType;
  customArrow?: React.ReactNode;
}) => {
  const isInteractive = !customArrow && byProvider.length > 0;
  const openProviders = () =>
    setAllProvidersModal({
      amount,
      label,
      byProvider,
      color,
      currency,
      isToday: true,
    });

  return (
    <Box
      $p="16px 20px"
      $pSM="12px 16px"
      $width="25%"
      $widthSM="100%"
      {...(isInteractive && {
        role: 'button',
        tabIndex: 0,
        $pointer: true,
        'aria-label': `${label}, ${formatAmount(
          amount,
          currency
        )}. Open provider breakdown`,
        onClick: openProviders,
        onKeyDown: (e: React.KeyboardEvent<HTMLDivElement>) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            openProviders();
          }
        },
      })}
    >
      <Div $flex $between $mb="8">
        <IconWrapper
          color={lightTheme.white}
          $background={color}
          $backgroundSize="40"
          $size="20"
        >
          <Icon />
        </IconWrapper>
        {customArrow ? (
          customArrow
        ) : isInteractive ? (
          <IconWrapper aria-hidden="true" color={lightTheme.lightGray} $pointer>
            <ArrowRed />
          </IconWrapper>
        ) : null}
      </Div>
      <H5 $mb="0">{label}</H5>
      <H3 $mb="0" $color={color}>
        {formatAmount(amount, currency)}
      </H3>
    </Box>
  );
};
